<template>
  <div class="bg-white grid grid-cols-info shadow-md mt-7 h-5/6">
    <div class="px-8 py-5"></div>
  </div>
</template>

<script setup>
</script>
